module.exports = __webpack_public_path__ + "img/checked.9e40f042.svg";